export const identityPoolId = 'us-east-2:c8f64552-2992-4bc2-8cb6-22b0a2ccc160'; //Cognito Identity Pool
export const region = 'us-east-2';
export const apiEndpoint = 'https://5mm8txxeqj.execute-api.us-east-2.amazonaws.com/prod/Token';